import { useAuth } from '../../contexts/AuthProvider';
import { AuthenticatedRoutes } from '../AuthenticatedRoutes/AuthenticatedRoutes';
import { PublicRoutes } from '../PublicRoutes/PublicRoutes';
import { AppErrorBoundary } from '../../components/BaseErrorBoundary';

export interface SwitchboardProps { }

// Summary: Chooses authenticated vs public router tree from current auth state.
// Details: docs/function-library/web/routes.md#routes-switchboard-switchboard
export const Switchboard: React.FC<SwitchboardProps> = () => {
    const { isAuthenticated } = useAuth();

    return (
        <AppErrorBoundary>
            {isAuthenticated ? <AuthenticatedRoutes /> : <PublicRoutes />}
        </AppErrorBoundary>
    );
};
